import {
  Button,
  Header,
  Modal,
  Table,
  Divider,
  Segment,
  Label,
} from 'semantic-ui-react';
import { useState } from 'react';
import Moment from 'react-moment';

function TabelaProcessos({ processos, meta, page, onPageChange }) {
  const [modalAberto, setModalAberto] = useState(false);
  const [processoSelecionado, setProcessoSelecionado] = useState(null);

  const abrirDetalhes = (processo) => {
    setProcessoSelecionado(processo);
    setModalAberto(true);
  };

  const fecharModal = () => {
    setModalAberto(false);
    setProcessoSelecionado(null);
  };

  const totalPaginas = meta.totalPaginas || 1;

  return (
    <>
      <Header as="h4" style={{ color: '#37536d' }}>
        Lista de Processos
        <Header.Subheader>
          Página {page} de {totalPaginas} ({meta.total || 0} registros)
        </Header.Subheader>
      </Header>

      <div style={{ fontSize: '0.85rem', color: '#666', marginBottom: '1rem', fontStyle: 'italic' }}>
        <strong>Legenda das Partes:</strong> <strong>CE</strong> Cliente Escritório (polo ativo) | <strong>PC</strong> Parte Contrária (polo passivo)
        <br />
        <span style={{ color: '#d9534f', fontWeight: 'bold' }}>■</span> <span style={{ color: '#d9534f' }}>Empresa não ativa</span>
      </div>

      <Table unstackable celled size="small" compact className="dnxTable" selectable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Pasta</Table.HeaderCell>
            <Table.HeaderCell>Número do Processo</Table.HeaderCell>
            <Table.HeaderCell>Objeto</Table.HeaderCell>
            <Table.HeaderCell>Partes</Table.HeaderCell>
            <Table.HeaderCell>Responsável</Table.HeaderCell>
            <Table.HeaderCell>Regional</Table.HeaderCell>
            <Table.HeaderCell>Área</Table.HeaderCell>
            <Table.HeaderCell>Situação</Table.HeaderCell>
            <Table.HeaderCell>Data</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {processos.length === 0 ? (
            <Table.Row>
              <Table.Cell colSpan="7" textAlign="center">
                Nenhum processo encontrado.
              </Table.Cell>
            </Table.Row>
          ) : (
            processos.map((processo) => {
              const primeiroObjeto = processo.objetos?.[0]?.descricao || '-';
              
              // Separa cliente (polo ativo) de não-clientes (polo passivo)
              const parteCliente = processo.envolvidos?.find(p => p.eCliente);
              const partesNaoCliente = processo.envolvidos?.filter(p => !p.eCliente) || [];
              const totalPartes = processo.envolvidos?.length || 0;
              
              // Monta exibição em duas linhas: [Cliente] / [Primeira não-cliente] + x mais
              let displayClienteEscritorio = parteCliente?.nome || '-';
              let displayParteContraria = partesNaoCliente[0]?.nome || '-';
              const totalMais = totalPartes - (parteCliente ? 1 : 0) - (partesNaoCliente.length > 0 ? 1 : 0);

              return (
                <Table.Row 
                  key={processo.id} 
                  onClick={() => abrirDetalhes(processo)}
                  style={{ cursor: 'pointer' }}
                >
                  <Table.Cell data-label="Pasta">
                    {processo.pasta}/{processo.pastaAno}
                  </Table.Cell>
                  <Table.Cell data-label="Processo">
                    {processo.processoOuSequencial || processo.numeroProcesso}
                  </Table.Cell>
                  <Table.Cell data-label="Objeto">
                    <div style={{ fontSize: '0.85rem' }}>
                      {primeiroObjeto}
                      {processo.objetos?.length > 1 && (
                        <div style={{ color: '#767676', marginTop: '0.25rem' }}>
                          +{processo.objetos.length - 1} mais
                        </div>
                      )}
                    </div>
                  </Table.Cell>
                  <Table.Cell data-label="Partes">
                    <div style={{ fontSize: '0.85rem' }}>
                      <div>
                        <strong>CE:</strong> 
                        <span>
                          {' '}{displayClienteEscritorio}
                          {parteCliente && !parteCliente.empresaAtiva && parteCliente.statusEmpresaArrecadacao && (
                            <span> ({parteCliente.statusEmpresaArrecadacao})</span>
                          )}
                        </span>
                      </div>
                      <div style={{ marginTop: '0.5rem' }}>
                        <strong>PC:</strong> 
                        <span style={{ 
                          color: partesNaoCliente[0] && !partesNaoCliente[0].empresaAtiva && partesNaoCliente[0].tipoPessoaEnvolvida === 'PJ' ? '#d9534f' : 'inherit',
                          fontWeight: partesNaoCliente[0] && !partesNaoCliente[0].empresaAtiva && partesNaoCliente[0].tipoPessoaEnvolvida === 'PJ' ? 'bold' : 'normal'
                        }}>
                          {' '}{displayParteContraria}
                          {partesNaoCliente[0] && !partesNaoCliente[0].empresaAtiva && partesNaoCliente[0].statusEmpresaArrecadacao && (
                            <span> ({partesNaoCliente[0].statusEmpresaArrecadacao})</span>
                          )}
                        </span>
                      </div>
                      {totalMais > 0 && (
                        <div style={{ color: '#767676', marginTop: '0.25rem' }}>
                          +{totalMais} mais
                        </div>
                      )}
                    </div>
                  </Table.Cell>
                  <Table.Cell data-label="Responsável">{processo.responsavel || '-'}</Table.Cell>
                  <Table.Cell data-label="Regional">{processo.regional || '-'}</Table.Cell>
                  <Table.Cell data-label="Área">{processo.area}</Table.Cell>
                  <Table.Cell data-label="Situação">
                    {processo.situacao || '-'}
                  </Table.Cell>
                  <Table.Cell data-label="Data">
                    {processo.dataAbertura ? (
                      <Moment format="DD/MM/YY" date={processo.dataAbertura} />
                    ) : '-'}
                  </Table.Cell>
                </Table.Row>
              );
            })
          )}
        </Table.Body>

        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell colSpan="9">
              <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', alignItems: 'center' }}>
                <Button
                  size="small"
                  disabled={page <= 1}
                  onClick={() => onPageChange(page - 1)}
                >
                  Anterior
                </Button>
                <span style={{ fontSize: '0.9rem', color: '#767676' }}>
                  {page} / {totalPaginas}
                </span>
                <Button
                  size="small"
                  disabled={page >= totalPaginas}
                  onClick={() => onPageChange(page + 1)}
                >
                  Próxima
                </Button>
              </div>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>

      {/* Modal de Detalhes */}
      <Modal open={modalAberto} onClose={fecharModal} size="large">
        <Modal.Header style={{ color: '#37536d' }}>
          Detalhes do Processo
        </Modal.Header>
        <Modal.Content scrolling>
          {processoSelecionado && (
            <>
              {/* Informações Básicas */}
              <Header as="h5" style={{ color: '#37536d', marginTop: 0 }}>
                Informações Básicas
              </Header>
              <Table definition size="small" compact>
                <Table.Body>
                  <Table.Row>
                    <Table.Cell width={4}>Pasta</Table.Cell>
                    <Table.Cell>
                      {processoSelecionado.pasta}/{processoSelecionado.pastaAno}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Número do Processo</Table.Cell>
                    <Table.Cell>
                      {processoSelecionado.processoOuSequencial || processoSelecionado.numeroProcesso}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Área</Table.Cell>
                    <Table.Cell>{processoSelecionado.area}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Situação</Table.Cell>
                    <Table.Cell>{processoSelecionado.situacao || '-'}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Responsável</Table.Cell>
                    <Table.Cell>{processoSelecionado.responsavel}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Regional</Table.Cell>
                    <Table.Cell>{processoSelecionado.regional || '-'}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Data Abertura</Table.Cell>
                    <Table.Cell>
                      {processoSelecionado.dataAbertura ? (
                        <Moment format="DD/MM/YYYY" date={processoSelecionado.dataAbertura} />
                      ) : '-'}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Assunto</Table.Cell>
                    <Table.Cell>{processoSelecionado.assunto || '-'}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Ano</Table.Cell>
                    <Table.Cell>{processoSelecionado.ano}</Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>

              <Divider />

              {/* Objetos da Ação */}
              <Header as="h5" style={{ color: '#37536d' }}>
                Objetos da Ação ({processoSelecionado.objetos?.length || 0})
              </Header>
              {processoSelecionado.objetos && processoSelecionado.objetos.length > 0 ? (
                <Segment size="small">
                  {processoSelecionado.objetos.map((obj, idx) => (
                    <div key={obj.id || idx} style={{ marginBottom: '0.5rem' }}>
                      <strong>{obj.descricao}</strong>
                    </div>
                  ))}
                </Segment>
              ) : (
                <Segment size="small" textAlign="center" style={{ color: '#999' }}>
                  Nenhum objeto cadastrado
                </Segment>
              )}

              <Divider />

              <Divider />

              {/* Partes Envolvidas - Organizadas por Polo */}
              <Header as="h5" style={{ color: '#37536d' }}>
                Partes Envolvidas ({processoSelecionado.envolvidos?.length || 0})
              </Header>
              {processoSelecionado.envolvidos && processoSelecionado.envolvidos.length > 0 ? (
                <>
                  {/* Polo Ativo (Cliente) */}
                  {processoSelecionado.envolvidos.filter(p => p.eCliente).length > 0 && (
                    <>
                      <Header as="h6" style={{ color: '#4183c4', marginTop: '1rem', marginBottom: '0.5rem' }}>
                        📌 Polo Ativo (Cliente)
                      </Header>
                      <Segment size="small">
                        {processoSelecionado.envolvidos
                          .filter(p => p.eCliente)
                          .map((parte, idx) => (
                            <div key={parte.id || idx} style={{ marginBottom: '1rem' }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
                                <strong>
                                  {parte.nome}
                                  {!parte.empresaAtiva && parte.statusEmpresaArrecadacao && (
                                    <span> ({parte.statusEmpresaArrecadacao})</span>
                                  )}
                                </strong>
                                {parte.eSocioAtivo && (
                                  <Label size="small" color="green">Sócio Ativo</Label>
                                )}
                                {!parte.empresaAtiva && parte.tipoPessoaEnvolvida === 'PJ' && (
                                  <Label size="small" color="red">Empresa Inativa</Label>
                                )}
                              </div>
                              {parte.matriculaSindical && (
                                <div style={{ fontSize: '0.85rem', color: '#767676' }}>
                                  Matrícula: {parte.matriculaSindical}
                                </div>
                              )}
                            </div>
                          ))}
                      </Segment>
                    </>
                  )}

                  {/* Polo Passivo (Demandados) */}
                  {processoSelecionado.envolvidos.filter(p => !p.eCliente).length > 0 && (
                    <>
                      <Header as="h6" style={{ color: '#4183c4', marginTop: '1rem', marginBottom: '0.5rem' }}>
                        📋 Polo Passivo (Demandados)
                      </Header>
                      <Segment size="small">
                        {processoSelecionado.envolvidos
                          .filter(p => !p.eCliente)
                          .map((parte, idx) => (
                            <div key={parte.id || idx} style={{ marginBottom: '1rem' }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
                                <strong style={{
                                  color: !parte.empresaAtiva && parte.tipoPessoaEnvolvida === 'PJ' ? '#d9534f' : 'inherit',
                                }}>
                                  {parte.nome}
                                  {!parte.empresaAtiva && parte.statusEmpresaArrecadacao && (
                                    <span> ({parte.statusEmpresaArrecadacao})</span>
                                  )}
                                </strong>
                                {parte.eSocioAtivo && (
                                  <Label size="small" color="green">Sócio Ativo</Label>
                                )}
                                {!parte.empresaAtiva && parte.tipoPessoaEnvolvida === 'PJ' && (
                                  <Label size="small" color="red">Empresa Inativa</Label>
                                )}
                              </div>
                              {parte.matriculaSindical && (
                                <div style={{ fontSize: '0.85rem', color: '#767676' }}>
                                  Matrícula: {parte.matriculaSindical}
                                </div>
                              )}
                            </div>
                          ))}
                      </Segment>
                    </>
                  )}
                </>
              ) : (
                <Segment size="small" textAlign="center" style={{ color: '#999' }}>
                  Nenhuma parte envolvida cadastrada
                </Segment>
              )}
            </>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={fecharModal}>Fechar</Button>
        </Modal.Actions>
      </Modal>
    </>
  );
}

export default TabelaProcessos;
